import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { FeedEntry } from "@app/dashboard/model/rss-top";
import { RSSFeedService } from "@app/dashboard/services/rss-feed.service";
import { htmlDecoder } from "@app/shared/resources/html-decoder";
import { Observable } from "rxjs";

@Component({
    selector: "app-rss-feed-dashboard-widget",
    templateUrl: "./rss-feed-dashboard-widget.component.html",
    styleUrls: ["./rss-feed-dashboard-widget.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RssFeedDashboardWidgetComponent implements OnInit {
    public feed$: Observable<any>;

    constructor(private rssFeedService: RSSFeedService) {}

    ngOnInit() {
        this.feed$ = this.rssFeedService.getFeedContent();
    }

    filterRSSByDate(feedEntry: FeedEntry) {
        const now = new Date();
        now.setDate(now.getDate() - 90);
        const pubDate = Date.parse(feedEntry.pubDate);
        return pubDate > now.getTime();
    }

    extractDescriptionText(feed) {
        return htmlDecoder(feed.description, true);
    }
}
